import React from 'react';
import PropTypes from 'prop-types';
import '../App.css';

function AddButton({ inTeam, onAddToTeam }) {
  const [hovered, setHovered] = React.useState(false);

  const label  = inTeam ? (hovered ? '✕ Remove' : '✓ Added') : '+ Add';
  const color  = inTeam ? (hovered ? '#e05252' : '#777')      : '#e8b84b';
  const border = inTeam ? (hovered ? '#e05252' : '#444')      : '#e8b84b';
  const bg     = inTeam ? (hovered ? 'rgba(224,82,82,0.12)' : 'rgba(255,255,255,0.04)') : 'rgba(232,184,75,0.15)';

  return (
    <button
      onClick={e => { e.stopPropagation(); onAddToTeam(); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'block',
        width: '100%',
        marginTop: '0.4rem',
        padding: '3px 0',
        fontSize: '0.68rem',
        fontWeight: 700,
        borderRadius: '4px',
        border: `1px solid ${border}`,
        background: bg,
        color,
        cursor: 'pointer',
        letterSpacing: '0.04em',
        transition: 'all 0.15s',
        textAlign: 'center',
        whiteSpace: 'nowrap',
      }}
      title={inTeam ? 'Remove from team' : 'Add to team'}
    >
      {label}
    </button>
  );
}

export default function PokemonCard({
  id,
  name,
  types,
  pastTypes,
  image,
  active,
  onClick,
  showAddButton,
  inTeam,
  onAddToTeam,
}) {
  const displayName = name.charAt(0).toUpperCase() + name.slice(1);

  return (
    <div
      className={`pokemon-card${active ? ' greyed' : ''}`}
      onClick={onClick}
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <img src={image} alt={displayName} style={{ display: 'block' }} />
      <h2 style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        fontSize: '0.9rem',
        margin: '0.3rem 0 0.2rem',
        textAlign: 'center',
      }}>{displayName}</h2>
      <p style={{
        fontSize: '0.7rem',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        margin: '0',
        color: '#a09080',
        width: '100%',
        textAlign: 'center',
      }}>
        {types.join(' · ')}
      </p>

      {pastTypes.length > 0 && (
        <ul style={{ width: '100%', padding: 0, margin: '0.2rem 0 0' }}>
          {pastTypes.map(pt => (
            <li key={pt.generation} style={{ fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {pt.types.join(', ')}
            </li>
          ))}
        </ul>
      )}

      {/* Spacer so button always has room even without showAddButton */}
      {showAddButton
        ? <AddButton inTeam={inTeam} onAddToTeam={onAddToTeam} />
        : <div style={{ height: '1.4rem', marginTop: '0.4rem' }} />
      }
    </div>
  );
}

PokemonCard.propTypes = {
  name:          PropTypes.string.isRequired,
  types:         PropTypes.arrayOf(PropTypes.string).isRequired,
  pastTypes:     PropTypes.arrayOf(
    PropTypes.shape({
      generation: PropTypes.string.isRequired,
      types:      PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ),
  image:         PropTypes.string.isRequired,
  active:        PropTypes.bool,
  onClick:       PropTypes.func,
  showAddButton: PropTypes.bool,
  inTeam:        PropTypes.bool,
  onAddToTeam:   PropTypes.func,
};

PokemonCard.defaultProps = {
  pastTypes:     [],
  active:        false,
  onClick:       () => {},
  showAddButton: false,
  inTeam:        false,
  onAddToTeam:   () => {},
};